import { render } from "./Whitelist.vue?vue&type=template&id=5976a706"
import script from "./Whitelist.vue?vue&type=script&lang=js"
export * from "./Whitelist.vue?vue&type=script&lang=js"

import "./Whitelist.vue?vue&type=style&index=0&id=5976a706&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__